import { IGetEmpreendimentoBlocoTableUseCase } from "../../../presentation/useCases/read/get_empreendimento_bloco_table_use_case";
import { ListaEmpreendimentoBlocoCompletoTable } from "../../models/empreendimentoBlocoTable";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * getEmpreendimentoBlocoTableUseCase
 */

export class GetEmpreendimentoBlocoTableUseCase implements IGetEmpreendimentoBlocoTableUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }

  async getEmpreendimentoBlocoTable(idBlocos: number[]): Promise<ListaEmpreendimentoBlocoCompletoTable> {
    const response = await this.repository.getEmpreendimentoBlocoTable(idBlocos)
    return response
  }
}
